export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10336.45cacde0.jpg";